// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1UserAccountPropertiesUpdateSchema = z.object({
  user_account_properties: z.optional(z.array(z.union([z.object({
    id: z.number().int().describe("UserAccountProperty id"),
    value: z.coerce.string().min(1).max(50),
  }), z.object({
    id: z.number().int().describe("UserAccountProperty id"),
    _destroy: z.boolean().describe("Must be **true** in order to delete a property"),
  }), z.object({
    account_user_property_id: z.number().int(),
    value: z.coerce.string().min(1).max(50),
  })])).describe("Item can describe **update** | **destroy** | **create** actions")),
});
